import { render, staticRenderFns } from "./TradeOrder.vue?vue&type=template&id=58773afa"
import script from "./TradeOrder.vue?vue&type=script&lang=js"
export * from "./TradeOrder.vue?vue&type=script&lang=js"
import style0 from "./TradeOrder.vue?vue&type=style&index=0&id=58773afa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports